// Header.tsx
import React, { useState } from 'react';
import { IoArrowBack, IoNotifications } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUniversityData } from '@/services/universityService';
import NotificationModal from '@/components/NotificationModal';

interface HeaderProps {
  user: any;
}

const ArrowBackIcon = IoArrowBack as React.ComponentType<{ className?: string }>;
const NotificationsIcon = IoNotifications as React.ComponentType<{ className?: string }>;

const Header: React.FC<HeaderProps> = ({ user }) => {
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const university = location.pathname.split('/')[2] || null;
  const universityId = university ? parseInt(university) : null;
  const showBack = !!university;
  
  // Fetch university data when on a university page
  const { data: universityData } = useUniversityData(universityId || 0);

  return (
    <header className="sticky top-0 z-50 w-full border-b flex items-center justify-between px-8 py-4 shadow-sm" style={{ background: 'var(--surface-secondary)', borderColor: 'var(--border-primary)' }}>
      <div className="flex items-center space-x-4">
        {showBack && (
          <>
            <button onClick={() => navigate(-1)} className="p-2 rounded-lg hover:bg-[var(--surface-hover)] transition-colors">
              <ArrowBackIcon className="text-xl" />
            </button>
            <div className="w-[500px] hidden lg:block">
              <div className="flex items-baseline space-x-5 mb-1">
                <span className="text-lg font-medium">
                  {universityData?.university_name || 'Loading...'}
                </span>
                <div className="flex items-center space-x-2" data-tour="text-notifications">
                  <span className="text-sm font-medium" style={{ color: 'var(--text-tertiary)' }}>
                    Due in {universityData?.days_remaining || 0} Days
                  </span>
                  <button
                    className="p-1 rounded hover:bg-[var(--surface-hover)] transition-colors"
                    onClick={() => setShowNotificationModal(true)}
                    title="Notification settings"
                  >
                    <span style={{ color: 'var(--text-tertiary)' }}><NotificationsIcon className="text-sm" /></span>
                  </button>
                </div>
              </div>
              <div className="flex h-2 space-x-1 max-w-[260px]">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div
                    key={i}
                    className={`flex-1 rounded ${
                      i < 3 ? 'bg-orange-500' : 'bg-[var(--border-primary)]'
                    }`}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      <div className="flex-grow"></div>

      <div className="flex items-center space-x-3">
        {/* Removed duplicate icons - they're now in the sidebar */}
      </div>
      <NotificationModal 
        isOpen={showNotificationModal}
        onClose={() => setShowNotificationModal(false)}
        user={user}
        schoolName={universityData?.university_name}
      />
    </header>
  );
};

export default Header;
